import axios from "axios";
// * constants
import { apiUrls } from "../utils/urls";

const axiosClient = axios.create({
  baseURL: apiUrls.baseURL,
});

export default axiosClient;
